'use strict';

export class MyAccount {
    #my_account_links_buttons;

    constructor() {
        this.#my_account_links_buttons = document.querySelectorAll('body.woocommerce-account a[levcharity-url]');
        this.addEvents();

    }

    addEvents() {
        if(this.#my_account_links_buttons){
            this.#my_account_links_buttons.forEach((button)=>{
               let link =  button.getAttribute('levcharity-url');
               if(link){
                   button.setAttribute('href', link);
                   button.removeAttribute('levcharity-url');
               }
            });
        }
    }

}
